import React from 'react'
import { Breadcrumb } from 'antd';
import { connect } from "react-redux";
import actionWays from '../../../redux/actions.js';
import Top from '../Top'
import Footer from '../Footer.js'
import './aboutUs.scss'
import SurroundingFacility from '../../common/SurroundingFacility'
class AboutUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabData: [],
            loading: false,
            rawHTML: '',
            rightTitle: '',
            downLoadList: [],
        }
    }
    componentDidMount() {
        this.setState({
            loading: true,
        })
    }
    render() {
        const { loading } = this.state;
        return (
            <div id={'aboutUs'} style={{ background: '#fff' }}>
                <Top />
                {loading ? <div>
                    <div className='aboutUs_top'></div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div style={{ paddingLeft: '7px', margin: '1em 0' }}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>首页</Breadcrumb.Item>
                                <Breadcrumb.Item>关于我们</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className='aboutUs_box'>
                            <div className='auBox_top'>
                                <div className='auBox_top_left'></div>
                                <div className='auBox_top_right'>
                                    <p className='auBox_top_right_title'>上海奉贤保障性住房有限公司</p>
                                    <p className='auBox_top_right_content' style={{ textIndent: '2em' }}>
                                        上海奉贤保障性住房有限公司（简称“奉贤保障房”）隶属于上海奉贤发展（集团）有限公司，成立于2011年9月，注册资本3亿元，系区属国有独资企业，主要承担着奉贤公共租赁住房投资、建设和运营、管理职能。
                                    </p>
                                    <p className='auBox_top_right_content' style={{ textIndent: '2em' }}>
                                        公司是上海市房产经济学会住房保障专委会理事单位、奉贤区建筑业联合会会员单位，被评为“上海市和谐劳动关系达标企业”，先后荣获上海市房屋管理实事立功竞赛优秀公司、奉贤区文明单位、奉贤区先进基层党组织等市、区级荣誉。公司优质的服务广受好评，近年来多次收到整体租赁单位、租户的感谢信和锦旗。
                                    </p>
                                </div>
                            </div>
                            <div className='auBox_btm'>
                                <div className='auBox_btm_left'>
                                    <SurroundingFacility dataLocation={'上海市奉贤区望园南路与百秀路辅路交叉口西南140米'} dataCommunityName={'中企联合大厦13层'} />
                                </div>
                                <div className='auBox_btm_right'>
                                    <p className='auBox_btm_right_content'>
                                        受理部门：上海奉贤保障性住房有限公司运营管理部
                                        <br />
                                        地址：上海市奉贤区南桥镇百秀路399号（中企联合大厦）13层
                                        <br />
                                        咨询受理电话：021-67188885
                                        <br />
                                        分机号1 咨询内容：准入资格申请受理、复审续租、期房过渡、总租赁年限到期过渡等公租政策类咨询。
                                        <br />
                                        分机号2咨询内容：车位租赁、退租办理、智能门锁授权等租后服务类咨询。
                                        <br />
                                        分机号3咨询内容：租金缴纳、发票开具等租金类咨询。
                                        <br />
                                        分机号4咨询内容：室内报修、网络宽带等报修服务类咨询。
                                        <br />
                                        分机号0咨询内容：其他业务
                                        <br />
                                        邮编：201499
                                    </p>
                                    <p className='auBox_btm_right_content2'>
                                        <span>申请受理时间：</span>
                                        <span style={{ marginRight: '30px' }}>
                                            周一至周五
                                            <br />
                                            上午8:30-11:00
                                            <br />
                                            下午13:00-16:30
                                        </span>
                                        <span>
                                            周六
                                            <br />
                                            上午8:30-11:00
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                    <Footer />
                </div> : ''}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AboutUs)
